var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container booking-requests-container"},[_c('div',{staticClass:"col-12 mt-3 d-flex flex-md-row flex-column justify-content-between align-items-center"},[_c('h1',[_vm._v("Booking Requests")]),_c('copy-booking-portal-url')],1),_c('div',{staticClass:"col-12 mt-3"},[_c('booking-requests-list')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }